// GENERATED by analysis/ons-initials/build_chapter3_dataset.py — do not hand-edit.
// Popularity: ONS Baby Names E&W 2016-2025 first-initial share (OGL v3.0).
// Value: PlateX genuine dateless auction sales (types 0/6/10), pooled per
// first letter, sales-weighted mean of group medians. Indices normalised to
// the max letter = 100. Trend + findings computed, not authored.

export interface Chapter3Datum { pop: number; val: number; ev: 'full' | 'mid' | 'sparse'; note: string; }

export const CHAPTER3_DATA: { [l: string]: Chapter3Datum } = {
 "A": {
  pop: 100.0,
  val: 86.0,
  ev: "full",
  note: "14.08% of E&W first initials \u00b7 8,079 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,785"
 },
 "B": {
  pop: 20.0,
  val: 68.0,
  ev: "full",
  note: "2.82% of E&W first initials \u00b7 6,344 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,785"
 },
 "C": {
  pop: 28.2,
  val: 75.0,
  ev: "full",
  note: "3.97% of E&W first initials \u00b7 7,045 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,175"
 },
 "D": {
  pop: 21.9,
  val: 75.3,
  ev: "full",
  note: "3.09% of E&W first initials \u00b7 7,304 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,191"
 },
 "E": {
  pop: 57.7,
  val: 63.5,
  ev: "full",
  note: "8.12% of E&W first initials \u00b7 5,043 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,534"
 },
 "F": {
  pop: 26.1,
  val: 59.7,
  ev: "mid",
  note: "3.67% of E&W first initials \u00b7 3,967 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,325"
 },
 "G": {
  pop: 16.2,
  val: 74.7,
  ev: "full",
  note: "2.28% of E&W first initials \u00b7 6,940 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,156"
 },
 "H": {
  pop: 36.4,
  val: 66.2,
  ev: "full",
  note: "5.13% of E&W first initials \u00b7 5,866 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,685"
 },
 "I": {
  pop: 27.5,
  val: 39.8,
  ev: "sparse",
  note: "3.87% of E&W first initials \u00b7 742 genuine dateless auction sales \u00b7 sales-weighted median value \u00a32,213"
 },
 "J": {
  pop: 40.4,
  val: 82.3,
  ev: "full",
  note: "5.69% of E&W first initials \u00b7 10,457 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,581"
 },
 "K": {
  pop: 17.4,
  val: 63.2,
  ev: "full",
  note: "2.45% of E&W first initials \u00b7 5,113 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,516"
 },
 "L": {
  pop: 50.1,
  val: 67.6,
  ev: "full",
  note: "7.06% of E&W first initials \u00b7 7,364 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,761"
 },
 "M": {
  pop: 64.3,
  val: 84.9,
  ev: "full",
  note: "9.05% of E&W first initials \u00b7 9,631 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,723"
 },
 "N": {
  pop: 21.6,
  val: 68.5,
  ev: "full",
  note: "3.04% of E&W first initials \u00b7 6,452 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,813"
 },
 "O": {
  pop: 25.6,
  val: 100.0,
  ev: "mid",
  note: "3.61% of E&W first initials \u00b7 4,872 genuine dateless auction sales \u00b7 sales-weighted median value \u00a35,566"
 },
 "P": {
  pop: 14.9,
  val: 71.4,
  ev: "full",
  note: "2.1% of E&W first initials \u00b7 7,395 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,973"
 },
 "Q": {
  pop: 0.7,
  val: 0.0,
  ev: "sparse",
  note: "0.1% of E&W first initials \u00b7 no genuine dateless auction sales recorded for this initial"
 },
 "R": {
  pop: 42.3,
  val: 74.9,
  ev: "full",
  note: "5.96% of E&W first initials \u00b7 9,585 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,167"
 },
 "S": {
  pop: 37.8,
  val: 87.3,
  ev: "full",
  note: "5.32% of E&W first initials \u00b7 10,428 genuine dateless auction sales \u00b7 sales-weighted median value \u00a34,860"
 },
 "T": {
  pop: 26.6,
  val: 70.8,
  ev: "full",
  note: "3.75% of E&W first initials \u00b7 7,235 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,939"
 },
 "U": {
  pop: 1.1,
  val: 64.5,
  ev: "mid",
  note: "0.16% of E&W first initials \u00b7 2,620 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,588"
 },
 "V": {
  pop: 6.3,
  val: 65.5,
  ev: "mid",
  note: "0.89% of E&W first initials \u00b7 3,183 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,647"
 },
 "W": {
  pop: 8.9,
  val: 64.0,
  ev: "mid",
  note: "1.26% of E&W first initials \u00b7 4,555 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,560"
 },
 "X": {
  pop: 0.8,
  val: 59.6,
  ev: "mid",
  note: "0.11% of E&W first initials \u00b7 3,330 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,317"
 },
 "Y": {
  pop: 4.5,
  val: 68.6,
  ev: "mid",
  note: "0.64% of E&W first initials \u00b7 3,010 genuine dateless auction sales \u00b7 sales-weighted median value \u00a33,818"
 },
 "Z": {
  pop: 12.6,
  val: 0.0,
  ev: "sparse",
  note: "1.78% of E&W first initials \u00b7 no genuine dateless auction sales recorded for this initial"
 }
};

export const CHAPTER3_TREND = { slope: 0.2047, intercept: 64.95, r: 0.391, n: 24 };

export const CHAPTER3_FINDINGS: string[] = ["\u201cA\u201d is the most common first initial, but ranks #3 of 26 for value.", "\u201cO\u201d carries the highest verified-sales value at \u00a35,566 weighted median, ranking #13 of 26 for popularity.", "Across the alphabet, popularity and value are only weakly related (r = 0.39 over 24 initials with sales evidence)."];
